import React, { useEffect, useState } from 'react';

const Sitemap = () => {
  const [content, setContent] = useState('Loading sitemap...');

  useEffect(() => {
        fetch(`${API}/sitemap.xml`)
      .then(res => res.text())
      .then(data => setContent(data))
      .catch(err => setContent('Error loading sitemap'));
  }, []);

  return (
    <pre style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', padding: '20px' }}>
      {content}
    </pre>
  );
};

export default Sitemap;
